import React from 'react';
import { useTranslation } from 'react-i18next';
import MainButton from '../../../../components/buttons/main';

const CheckoutTipsHeader = ({ onOpenMenu }) => {
  const { t } = useTranslation();
  return (
    <div className="overflow-hidden sm:px-3 -mx-5 pb-6">
      <div className="box-shadow2 pb-5 px-5 bg-white rounded-b-3xl shadow-[0_3px_17px_rgba(17,24,39,0.1)]">
        <div className="flex justify-center">
          <div className="max-w-xs w-full">
            <MainButton text={t('buttons.viewMenu')} outline onClick={onOpenMenu} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutTipsHeader;
